<template>
	<AbsoluteInternalLink
		v-if="blok.content"
		:to="{name: 'recepty-autori-slug', params: {slug: blok.slug}}"
		class="
			inline-flex
			items-center
			rounded-full
			text-body-inverse
			typo-body-caption
			px-1
			py-1
			z-10
			transition
			ease
		"
		:class="isDark ? 'bg-background-dark hover:bg-background-dark/90' : 'bg-background-darker/60 hover:bg-background-darker/70 backdrop-blur-xs'"
	>
		<div class="relative rounded-full overflow-hidden shrink-0 w-6 h-6">
			<NuxtPicture
				v-if="blok.content.image?.filename"
				provider="storyblok"
				:modifiers="storyblokFocusModifiers(blok.content.image.focus)"
				:src="blok.content.image.filename"
				:alt="blok.content.image.alt || ''"
				width="24"
				height="24"
				sizes="inf:24px"
				:img-attrs="{class:'cover-parent object-cover'}"
				loading="lazy"
			/>
		</div>
		<span class="px-2">{{ blok.content.title }}</span>
	</AbsoluteInternalLink>
</template>

<script setup lang="ts">
	import type {StoryblokStory} from 'storyblok-generate-ts';
	import type {AuthorBadgeStoryBlok} from '@/types/authorBadge';
	import type {PageTypeRecipesAuthorDetailStoryblok} from '@/storyblok/types';

	type Props = {
		blok: AuthorBadgeStoryBlok | StoryblokStory<PageTypeRecipesAuthorDetailStoryblok>;
		isDark?: boolean;
	};

	defineProps<Props>();
</script>
